import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { volumes } from '../data/volumes';
export function TomosSection() {
  return <section className="py-24 px-4 bg-cream-beige" data-id="element-292" data-mp="1p3k3kpf5yb2u">
      <div className="max-w-6xl mx-auto" data-id="element-293" data-mp="1p4vbn1fn64zr">
        <div className="text-center mb-16" data-id="element-294" data-mp="1u2naygim8tdz">
          <p className="text-navy-mid font-bold tracking-widest uppercase mb-3 text-sm" data-id="element-295" data-mp="1u1lqjlfpmujl">
            What you get: 6 complete resources in one single package
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold mb-4 text-navy-deep" data-id="element-296" data-mp="11dg1imhmijdy">
            📚 The <span className="text-gold" data-id="element-297" data-mp="16dc9ewtfyuys">4-Volume Lesson Library</span>
          </h2>
          <p className="text-xl text-navy-mid" data-id="element-298" data-mp="1bc5naqcn4nzh">
            100 complete lessons · All levels covered · Nothing to build from
            scratch
          </p>
          <p className="text-base text-warmgray mt-3 max-w-2xl mx-auto" data-id="element-299" data-mp="2hrpphfhye649">
            4 complete lesson volumes + 2 essential teaching tools — all
            structured, all ready, nothing to build from scratch.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-300" data-mp="2mmnbcaj740e9">
          {volumes.map((volume, index) => <motion.article key={volume.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} whileHover={{
          y: -5
        }} className={`bg-cream-card rounded-2xl border ${volume.popular ? 'border-gold shadow-[0_16px_40px_-24px_rgba(194,155,44,0.8)]' : 'border-gold-light shadow-sm'} p-8 relative overflow-hidden flex flex-col h-full`} data-id="element-301" data-mp="2hnk3yjfqti34" data-mpi={index}>
              {volume.popular && <div className="absolute top-6 right-[-35px] bg-gold text-white font-bold text-xs py-1 px-10 rotate-45 shadow" data-id="element-302" data-mp="1oz4uecfdrrz6">
                  ⭐ MOST POPULAR
                </div>}
              <div className="flex items-center gap-4 mb-6" data-id="element-303" data-mp="1abwnhnt3u8t0">
                <span className="text-4xl" aria-hidden="true" data-id="element-304" data-mp="1aeiunmc32map">
                  {volume.icon}
                </span>
                <div data-id="element-305" data-mp="11brhni3k7igy">
                  <div className="text-gold font-bold text-sm uppercase tracking-wider" data-id="element-306" data-mp="11c9i6qx98iuo">
                    {volume.number}
                  </div>
                  <h3 className="text-2xl font-serif font-bold leading-tight mt-1 text-navy-deep" data-id="element-307" data-mp="15f600fez0axk">
                    {volume.title}
                  </h3>
                </div>
              </div>
              <p className="text-navy-mid font-medium mb-6 italic border-l-2 border-gold pl-4" data-id="element-308" data-mp="1y3uz68wgu66o">
                {volume.subtitle}
              </p>
              <div className="mb-6" data-id="element-309" data-mp="1ob5rlp41dcgm">
                <h4 className="text-sm font-bold text-warmgray uppercase tracking-wider mb-2" data-id="element-310" data-mp="1oa4ihq6kz01j">
                  What does this solve for your teaching?
                </h4>
                <p className="text-ink text-sm leading-relaxed" data-id="element-311" data-mp="2gt1oierrlw1g">
                  {volume.problem}
                </p>
              </div>
              <ul className="space-y-3 mb-8 flex-grow" data-id="element-312" data-mp="5awrv5sqt906">
                {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-313" data-mp="f32urakj9au5">
                    <CheckCircle2Icon size={18} className="text-forest shrink-0 mt-0.5" data-id="element-314" data-mp="f2axlvbaf51r" />
                    <span className="text-ink text-sm" data-id="element-315" data-mp="3ij9p2qh25vq9">{bullet}</span>
                  </li>)}
              </ul>
              <div className="bg-forest-soft border border-forest/30 rounded-xl p-4 mt-auto" data-id="element-316" data-mp="3dlzxp5a3z9zs">
                <span className="text-forest-deep font-bold block mb-1" data-id="element-317" data-mp="3siqr8xx3prhh">
                  Result:
                </span>
                <p className="text-ink text-sm" data-id="element-318" data-mp="3nhkwkujvru5b">{volume.result}</p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}